<template>
  <nav class="nav nav--topbar">
    <div
      v-if="isAdmin"
      :class="[
        'nav--toggle',
        { admin: routePath.includes('/admin') },
        { user: routePath.includes('/user') }
      ]"
    >
      <p>Member</p>
      <Toggler
        @toggle="$router.push('/admin/dashboard')"
        :withStatus="false"
        :value="routePath === '/admin'"
        class="role"
      />
      <p>Admin</p>
    </div>
    <router-link
      :to="{ name: 'UserCheckout' }"
      class="nav-item nav-item--cart"
      tag="button"
      :disabled="orders.length < 1"
    >
      <icon-base view-box="0 0 32 32" icon-name="Checkout">
        <IconCart />
      </icon-base>
      <span
        v-if="orders.length"
        class="badge badge-primary"
        :style="{ backgroundColor: primary }"
      >
        {{ orders.length }}
      </span>
    </router-link>
    <router-link to="/user/dashboard" class="nav-item" tag="button">
      <icon-base view-box="0 0 32 32" icon-name="Home">
        <IconHome />
      </icon-base>
    </router-link>
    <TopbarNavProfile class="nav-item nav-item--profile ml-3" />
  </nav>
</template>

<script>
import { IconHome, IconCart } from "@/components/icons";
import TopbarNavProfile from "@/modules/user/elements/TopbarNavProfile";
import { mapActions, mapGetters } from "vuex";
import Toggler from "@/components/Toggler";

export default {
  components: {
    TopbarNavProfile,
    IconHome,
    IconCart,
    Toggler
  },
  data() {
    return {
      colorSchemeDefault: {
        id: 0,
        primary: "#51B67E",
        secondary: "#E1FAF4",
        event: "#2A774C",
        danger: "#dc3545"
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    scheme() {
      return this.$store.state.concierge.schemeList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    orders() {
      return this.getOrders();
    },
    routePath() {
      const [, rootRoute] = this.$route.path.split("/");
      return "/" + rootRoute;
    },
    isAdmin() {
      const loggedUser = this.$store.getters.getUser;
      if (loggedUser.Roles && loggedUser.Roles.length > 0) {
        const role = loggedUser.Roles.find(role => role.value === 8);
        if (role) return true;
      }

      return false;
    }
  },
  async created() {
    let updatedScheme = JSON.parse(localStorage.getItem("colorScheme"));
    if (!updatedScheme) {
      await this.$store.dispatch("fetchScheme");
      updatedScheme = this.scheme.length
        ? this.scheme[0].value
        : this.colorSchemeDefault;
      localStorage.setItem("colorScheme", JSON.stringify(updatedScheme));
    }
    this.updateScheme(updatedScheme);
  },
  methods: {
    ...mapActions(["updateScheme"]),
    ...mapGetters(["getOrders"])
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/custom/_dropdown.scss";
@import "node_modules/bootstrap/scss/mixins/_breakpoints.scss";

.nav {
  &--topbar {
    align-items: center;
  }

  button.nav-item {
    background: transparent;
    border: 0;
    border-radius: 50%;
    overflow: hidden;
    padding: 0;
    position: relative;
    transition: background 60ms ease-out;
    &::before {
      content: "";
      background-color: $gray-200;
      border-radius: 50%;
      height: 100%;
      left: 0;
      transform: scale(0);
      transition: all 0.2s ease-out;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }

    &:hover {
      cursor: pointer;
      &::before {
        transform: scale(1);
      }
    }

    &--cart {
      overflow: visible;
      display: block;
    }
  }

  &-item {
    display: none;
    height: 2.5rem;
    margin: auto 0.25rem;
    position: relative;
    width: 2.5rem;

    @include media-breakpoint-up(md) {
      display: block;
    }

    &--profile {
      display: block;
    }

    &:disabled,
    &--disabled {
      pointer-events: none;
      opacity: 0.6;
    }

    .btn {
      background-color: transparent;
      border: 0;
      border-radius: 2.5rem !important;
      transition: background 60ms ease-out;
      &::before {
        content: "";
        background-color: $gray-200;
        border-radius: 50%;
        height: 100%;
        left: 0;
        transform: scale(0);
        transition: all 0.2s ease-out;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: -1;

        @media screen and (max-width: 639px) {
          background-color: transparent;
        }
      }

      &:hover {
        cursor: pointer;
        &::before {
          transform: scale(1);
        }
      }
    }

    svg {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  .btn {
    height: 2.5rem;
    padding: 0;
    width: 2.5rem;
  }

  .badge {
    border: 1.25rem;
    border-radius: 1.25rem;
    font-size: 0.75rem;
    font-weight: 400;
    height: 1.25rem;
    line-height: 1rem;
    min-width: 1.25rem;
    padding: 0.125rem 0.25rem;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(25%);
  }

  .dropdown-menu {
    overflow: hidden;
    width: 100vw;
    height: 100vh;

    @media screen and (max-width: 639px) {
      max-height: unset !important;
      margin-left: -5px;
      margin-top: 10px;
      position: fixed !important;
      transform: none !important;
    }

    @media screen and (min-width: 640px) {
      width: 19.5rem;
      height: unset;
    }
  }

  &-dropdown {
    .dropdown {
      &-menu {
        padding: 0;
      }
      &-item {
        transition: background 60ms ease-out;
      }
      &__footer {
        text-align: center;
      }
    }
  }

  &--toggle {
    display: none;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin-right: 41px;

    @media screen and (min-width: 640px) {
      display: flex;
    }

    &.admin {
      .switch {
        background-color: #f0913b;
      }

      p:last-child {
        color: #f0913b;
      }
    }

    &.user {
      .switch {
        background-color: #0ec5dd;
      }

      p:first-child {
        color: #0ec5dd;
      }
    }

    .switch {
      background-color: #0ec5dd;

      .indicator {
        top: 4px;
        height: 12px;
        width: 12px;
      }
    }

    p {
      margin: 0;
      font-size: 1rem;
      font-weight: 500;
      color: #b7b7b7;
    }
  }
}
</style>
